import React, { Suspense } from 'react'
import { RouteChildrenProps } from 'react-router-dom'
import AppErrorDispatcher from '../components/organisms/AppErrorDispatcher'
import { PAGE_URL } from '../constants'
import AppBatteriesManagementDeleteBatteries from '../pages/AppBatteriesManagementDeleteBatteries'
import AppErrorPage from '../pages/AppErrorPage'
import Home from '../pages/AppHome/index.ts'
import AppLoading from '../pages/AppLoading'
import AppNotFoundPage from '../pages/AppNotFoundPage'
import {
  AppAUditManagementDashboard,
  AppAuditManagement,
  AppAuditManagementAnswerNew,
  AppAuditManagementAnswerUpdate,
  AppAuditManagementDetail,
  AppAuditManagementEntries,
  AppAuditManagementExport,
  AppAuditManagementExternalData,
  AppAuditManagementList,
  AppBatteriesManagement,
  AppBatteriesManagementAssignBattery,
  // AppBatteriesManagementReturnBattery,
  AppBatteriesManagementBatteryHistory,
  AppBatteriesManagementBatteryHistoryDetail,
  AppBatteriesManagementDashboard,
  AppBatteriesManagementDetailBattery,
  AppBatteriesManagementExport,
  AppBatteriesManagementExportLoader,
  AppBatteriesManagementImport,
  // AppBatteriesManagementAddBattery,
  AppBatteriesManagementInstallBattery,
  AppBatteriesManagementSiteDetail,
  AppBatteriesManagementStockControl,
  AppBatteriesManagementSummary,
  AppBreadcrumbDashboardDelete,
  AppBreadcrumbDashboardManagement,
  AppBreadcrumbDashboardNew,
  AppBreadcrumbDashboardUpdate,
  AppCategoryPollDelete,
  AppCategoryPollList,
  AppCategoryPollNew,
  AppCategoryPollUpdate,
  AppDashboard,
  AppDriveTestControl,
  AppDriveTestControlCollectionCycleNew,
  AppDriveTestControlCollectionCycleUpdate,
  AppDriveTestControlDashboard,
  AppDriveTestControlNew,
  AppDriveTestControlSettings,
  AppDriveTestControlUpdate,
  AppEquipmentManagement,
  AppEquipmentManagementStockControl,
  AppFieldModelManagement,
  AppFieldModelManagementCreate,
  AppFieldModelManagementEdit,
  AppFieldModelManagementImport,
  AppFormManagement,
  AppGroupsModelManagement,
  AppInboxManagementList,
  AppLayoutDashboardDelete,
  AppLayoutDashboardManagement,
  AppLayoutDashboardNew,
  AppLayoutDashboardUpdate,
  AppLayoutDashboardWidget,
  AppLayoutDashboardWidgetDelete,
  AppLayoutDashboardWidgetNew,
  AppLayoutDashboardWidgetUpdate,
  // AppBatteriesManagementAddBattery,
  // AppBatteriesManagementReturnBattery,
  AppModelManagementList,
  AppNewFieldModelManagement,
  AppPageTest,
  AppPollAnswerDelete,
  AppPollDelete,
  AppPollImport,
  AppPollNew,
  AppPollUpdate,
  AppProjectDelete,
  AppProjectManagement,
  AppProjectNew,
  AppProjectUpdate,
  AppReportNewFunctionality,
  AppReportTemplateManagement,
  AppSettings,
  AppSettingsMap,
  AppSettingsOthers,
  // AppBatteriesManagementAddBattery,
  // AppBatteriesManagementReturnBattery,
  AppSiteView,
  AppSiteVisits,
  AppSiteVisitsDashboard,
  AppSiteVisitsDetails,
  AppSiteVisitsGroupRealtimeDelete,
  AppSiteVisitsGroupRealtimeNew,
  AppSiteVisitsGroupRealtimeUpdate,
  AppSiteVisitsLive,
  AppSiteVisitsLiveView,
  AppSiteVisitsWorkInProgress,
  AppUserManagement,
  AppUserManagementActivity,
  AppUserManagementBusiness,
  AppUserManagementBusinessDelete,
  AppUserManagementBusinessNew,
  AppUserManagementBusinessUpdate,
  AppUserManagementChangePassword,
  AppUserManagementCompany,
  AppUserManagementCompanyDelete,
  AppUserManagementCompanyNew,
  AppUserManagementCompanyUpdate,
  AppUserManagementDelete,
  AppUserManagementNew,
  AppUserManagementProfiles,
  AppUserManagementProfilesDelete,
  AppUserManagementProfilesNew,
  AppUserManagementProfilesUpdate,
  AppUserManagementSecurity,
  AppUserManagementUpdate
} from './lazyLoadedComponents'

export type RouteAppComponentProps = RouteChildrenProps & {
  routes?: Routes[]
  pageName: string
}

export type Routes = {
  path: string | string[]
  exact?: boolean
  strict?: boolean
  search?: string
  sensitive?: boolean
  component: (props: RouteAppComponentProps) => JSX.Element | null
  routes?: Routes[]
  pageName: string
}

function suspenseWrapper(
  Component: (props: RouteAppComponentProps) => JSX.Element | null
) {
  return (props: RouteAppComponentProps): JSX.Element => (
    <Suspense fallback={<AppLoading />}>
      {Component && <Component {...props} />}
    </Suspense>
  )
}

const routes: Routes[] = [
  {
    path: PAGE_URL.HOME,
    component: Home,
    pageName: '',
    routes: [
      {
        path: PAGE_URL.ERROR_404,
        component: AppNotFoundPage,
        exact: true,
        pageName: 'Not Found'
      },
      {
        path: PAGE_URL.ERROR_PAGE,
        component: AppErrorPage,
        exact: true,
        pageName: 'Error Page'
      },
      {
        path: PAGE_URL.HOME,
        component: suspenseWrapper(AppDashboard),
        exact: true,
        pageName: ''
      },
      {
        path: PAGE_URL.FORMS_MANAGEMENT,
        exact: true,
        component: suspenseWrapper(AppFormManagement),
        pageName: 'Forms Management'
      },
      {
        path: PAGE_URL.POLL_NEW,
        exact: true,
        pageName: 'New Poll',
        component: suspenseWrapper(AppPollNew)
      },
      {
        path: PAGE_URL.POLL_IMPORT,
        exact: true,
        pageName: 'Import Poll',
        component: suspenseWrapper(AppPollImport)
      },
      {
        path: PAGE_URL.POLL_UPDATE,
        exact: true,
        component: suspenseWrapper(AppPollUpdate),
        pageName: 'Update Forms'
      },
      {
        path: PAGE_URL.POLL_DELETE,
        exact: true,
        component: suspenseWrapper(AppPollDelete),
        pageName: 'Delete Form'
      },
      {
        path: PAGE_URL.AUDIT_MANAGEMENT_DETAILS,
        exact: true,
        component: suspenseWrapper(AppAuditManagementDetail),
        pageName: 'Audit Details'
      },
      {
        path: PAGE_URL.AUDIT_MANAGEMENT_UPDATE_ANSWER,
        exact: true,
        pageName: 'Update Poll Answer',
        component: suspenseWrapper(AppAuditManagementAnswerUpdate)
      },
      {
        path: PAGE_URL.POLL_ANSWER_DELETE,
        exact: true,
        component: suspenseWrapper(AppPollAnswerDelete),
        pageName: 'Poll Answer Delete'
      },
      {
        path: PAGE_URL.AUDIT_MANAGEMENT_NEW_ANSWER,
        exact: true,
        pageName: 'New Poll Answer',
        component: suspenseWrapper(AppAuditManagementAnswerNew)
      },
      {
        path: PAGE_URL.AUDIT_MANAGEMENT_EXTERNAL_DATA,
        exact: true,
        pageName: 'Form External Data & Images',
        component: suspenseWrapper(AppAuditManagementExternalData)
      },
      {
        path: PAGE_URL.DRIVE_TEST_CONTROL_CONFIG,
        component: suspenseWrapper(AppDriveTestControlSettings),
        pageName: 'Drive Test Control Settings',
        exact: true
      },
      {
        path: PAGE_URL.DRIVE_TEST_CONTROL,
        component: suspenseWrapper(AppDriveTestControl),
        pageName: 'Drive Test Control',
        routes: [
          {
            path: PAGE_URL.DRIVE_TEST_CONTROL_DASHBOARD,
            component: AppDriveTestControlDashboard,
            pageName: 'Drive Test Control'
          },
          {
            path: PAGE_URL.DRIVE_TEST_CONTROL_NEW,
            pageName: 'Drive Test Control New',
            component: suspenseWrapper(AppDriveTestControlNew)
          },
          {
            path: PAGE_URL.DRIVE_TEST_CONTROL_UPDATE,
            pageName: 'Drive Test Control Update',
            component: suspenseWrapper(AppDriveTestControlUpdate)
          },
          {
            path: PAGE_URL.DRIVE_TEST_CONTROL_COLLECTION_CYCLE_NEW,
            pageName: 'Drive Test Control Collection Cycle New',
            component: suspenseWrapper(AppDriveTestControlCollectionCycleNew)
          },
          {
            path: PAGE_URL.DRIVE_TEST_CONTROL_COLLECTION_CYCLE_UPDATE,
            pageName: 'Drive Test Control Collection Cycle Update',
            component: suspenseWrapper(AppDriveTestControlCollectionCycleUpdate)
          }
        ]
      },
      {
        path: PAGE_URL.AUDIT_MANAGEMENT,
        component: suspenseWrapper(AppAuditManagement),
        pageName: 'Audit Management',
        routes: [
          {
            path: PAGE_URL.AUDIT_MANAGEMENT_LIST,
            exact: true,
            component: suspenseWrapper(AppAuditManagementList),
            pageName: 'Audit Management'
          },
          {
            path: PAGE_URL.AUDIT_MANAGEMENT_ENTRIES,
            exact: true,
            component: suspenseWrapper(AppAuditManagementEntries),
            pageName: 'Audit Management'
          },
          {
            path: PAGE_URL.AUDIT_MANAGEMENT_DASHBOARD,
            exact: true,
            component: suspenseWrapper(AppAUditManagementDashboard),
            pageName: 'Audit Management'
          },
          {
            path: PAGE_URL.AUDIT_MANAGEMENT_EXPORT,
            exact: true,
            component: suspenseWrapper(AppAuditManagementExport),
            pageName: 'Audit Management Export'
          },
          {
            path: '*',
            component: (): JSX.Element => (
              <AppErrorDispatcher errorStatusCode={404} />
            ),
            pageName: 'Audit Management'
          }
        ]
      },
      {
        path: PAGE_URL.CATEGORY_POll_LIST,
        exact: true,
        component: suspenseWrapper(AppCategoryPollList),
        pageName: 'Category Poll Management'
      },
      {
        path: PAGE_URL.CATEGORY_POll_NEW,
        exact: true,
        component: suspenseWrapper(AppCategoryPollNew),
        pageName: 'New Category'
      },
      {
        path: PAGE_URL.CATEGORY_POLL_UPDATE,
        exact: true,
        component: suspenseWrapper(AppCategoryPollUpdate),
        pageName: 'Update Category'
      },
      {
        path: PAGE_URL.CATEGORY_POLL_DELETE,
        exact: true,
        component: suspenseWrapper(AppCategoryPollDelete),
        pageName: 'Delete Category'
      },

      {
        path: PAGE_URL.MAINTENANCE_AUDIT_FORM,
        exact: true,
        component: suspenseWrapper(
          (): JSX.Element => <h1>Work in Progress</h1>
        ),
        pageName: 'Work in Progress'
      },
      {
        path: PAGE_URL.PROJECT_MANAGEMENT,
        exact: true,
        component: suspenseWrapper(AppProjectManagement),
        pageName: 'Project Management'
      },
      {
        path: PAGE_URL.PROJECT_NEW,
        exact: true,
        component: suspenseWrapper(AppProjectNew),
        pageName: 'New Project'
      },
      {
        path: PAGE_URL.PROJECT_UPDATE,
        exact: true,
        component: suspenseWrapper(AppProjectUpdate),
        pageName: 'Update Project'
      },
      {
        path: PAGE_URL.PROJECT_DELETE,
        exact: true,
        component: suspenseWrapper(AppProjectDelete),
        pageName: 'Delete Project'
      },
      {
        path: PAGE_URL.REPORT_TEMPLATE_LIST,
        exact: true,
        component: suspenseWrapper(AppReportTemplateManagement),
        pageName: 'Report Template Management'
      },
      {
        path: PAGE_URL.REPORT_NEW_FUNCTIONALITY,
        exact: true,
        component: suspenseWrapper(AppReportNewFunctionality),
        pageName: 'Report Template Management'
      },
      {
        path: PAGE_URL.BREADCRUMB_DASHBOARD_MANAGEMENT,
        exact: true,
        component: suspenseWrapper(AppBreadcrumbDashboardManagement),
        pageName: 'Dashboard Management'
      },
      {
        path: PAGE_URL.NEW_BREADCRUMB_DASHBOARD,
        exact: true,
        component: suspenseWrapper(AppBreadcrumbDashboardNew),
        pageName: 'Dashboard Management New Breadcrumb'
      },
      {
        path: PAGE_URL.UPDATE_BREADCRUMB_DASHBOARD,
        exact: true,
        component: suspenseWrapper(AppBreadcrumbDashboardUpdate),
        pageName: 'Dashboard Management Update Breadcrumb'
      },
      {
        path: PAGE_URL.DELETE_BREADCRUMB_DASHBOARD,
        exact: true,
        component: suspenseWrapper(AppBreadcrumbDashboardDelete),
        pageName: 'Dashboard Management Delete Breadcrumb'
      },
      {
        path: PAGE_URL.INBOX_MANAGEMENT_LIST,
        exact: true,
        component: suspenseWrapper(AppInboxManagementList),
        pageName: 'Inbox List'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_MANAGEMENT,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardManagement),
        pageName: 'Dashboard Management'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_UPDATE,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardUpdate),
        pageName: 'Update Dashboard'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_NEW,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardNew),
        pageName: 'New Dashboard'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_DELETE,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardDelete),
        pageName: 'Delete Dashboard'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_WIDGETS,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardWidget),
        pageName: 'Widget Management'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_WIDGETS_NEW,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardWidgetNew),
        pageName: 'New Widget'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_WIDGETS_UPDATE,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardWidgetUpdate),
        pageName: 'Update Widget'
      },
      {
        path: PAGE_URL.LAYOUT_DASHBOARD_WIDGETS_DELETE,
        exact: true,
        component: suspenseWrapper(AppLayoutDashboardWidgetDelete),
        pageName: 'Delete Widget'
      },
      {
        path: PAGE_URL.SETTINGS,
        exact: true,
        component: suspenseWrapper(AppSettings),
        pageName: 'Settings'
      },
      {
        path: PAGE_URL.SETTINGS_OTHERS,
        exact: true,
        component: suspenseWrapper(AppSettingsOthers),
        pageName: 'Other Settings'
      },
      {
        path: PAGE_URL.USER_MANAGEMENT,
        exact: true,
        component: suspenseWrapper(AppUserManagement),
        pageName: 'User Management'
      },
      {
        path: PAGE_URL.NEW_USER,
        exact: true,
        component: suspenseWrapper(AppUserManagementNew),
        pageName: 'New User'
      },
      {
        path: PAGE_URL.UPDATE_USER,
        exact: true,
        component: suspenseWrapper(AppUserManagementUpdate),
        pageName: 'Update User'
      },
      {
        path: PAGE_URL.CHANGE_PASSWORD,
        exact: true,
        pageName: 'Change Password',
        component: suspenseWrapper(AppUserManagementChangePassword)
      },
      {
        path: PAGE_URL.USER_DELETE,
        exact: true,
        pageName: 'Delete User',
        component: suspenseWrapper(AppUserManagementDelete)
      },
      {
        path: PAGE_URL.USER_ACTIVITY,
        exact: true,
        pageName: 'User Activities',
        component: suspenseWrapper(AppUserManagementActivity)
      },
      {
        path: PAGE_URL.USER_PROFILE,
        exact: true,
        pageName: 'Profile Management',
        component: suspenseWrapper(AppUserManagementProfiles)
      },
      {
        path: PAGE_URL.USER_PROFILE_NEW,
        exact: true,
        pageName: 'New Profile',
        component: suspenseWrapper(AppUserManagementProfilesNew)
      },
      {
        path: PAGE_URL.USER_PROFILE_UPDATE,
        exact: true,
        pageName: 'Update Profile',
        component: suspenseWrapper(AppUserManagementProfilesUpdate)
      },
      {
        path: PAGE_URL.USER_PROFILE_DELETE,
        exact: true,
        pageName: 'Delete Profile',
        component: suspenseWrapper(AppUserManagementProfilesDelete)
      },
      {
        path: PAGE_URL.USER_BUSINESS,
        exact: true,
        pageName: 'Business Management',
        component: suspenseWrapper(AppUserManagementBusiness)
      },
      {
        path: PAGE_URL.USER_BUSINESS_NEW,
        exact: true,
        pageName: 'New Business',
        component: suspenseWrapper(AppUserManagementBusinessNew)
      },
      {
        path: PAGE_URL.USER_BUSINESS_UPDATE,
        exact: true,
        pageName: 'Update Business',
        component: suspenseWrapper(AppUserManagementBusinessUpdate)
      },
      {
        path: PAGE_URL.USER_BUSINESS_DELETE,
        exact: true,
        pageName: 'Delete Business',
        component: suspenseWrapper(AppUserManagementBusinessDelete)
      },
      {
        path: PAGE_URL.USER_COMPANY,
        exact: true,
        pageName: 'Own Company Management',
        component: suspenseWrapper(AppUserManagementCompany)
      },
      {
        path: PAGE_URL.USER_COMPANY_NEW,
        exact: true,
        pageName: 'New Own Company',
        component: suspenseWrapper(AppUserManagementCompanyNew)
      },
      {
        path: PAGE_URL.USER_COMPANY_UPDATE,
        exact: true,
        pageName: 'Update Own Company',
        component: suspenseWrapper(AppUserManagementCompanyUpdate)
      },
      {
        path: PAGE_URL.USER_COMPANY_DELETE,
        exact: true,
        pageName: 'Delete Own Company',
        component: suspenseWrapper(AppUserManagementCompanyDelete)
      },
      {
        path: PAGE_URL.USER_SECURITY,
        exact: true,
        pageName: 'User Security',
        component: suspenseWrapper(AppUserManagementSecurity)
      },
      {
        path: PAGE_URL.BATTERIES_MANAGEMENT,
        pageName: 'Batteries Management',
        component: suspenseWrapper(AppBatteriesManagement),
        routes: [
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_DASHBOARD,
            pageName: 'Batteries Dashboard',
            exact: true,
            component: suspenseWrapper(AppBatteriesManagementDashboard)
          },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_SUMMARY,
            pageName: 'Summary',
            component: suspenseWrapper(AppBatteriesManagementSummary),
            exact: true
          },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_STOCK_CONTROL,
            pageName: 'Stock Control',
            component: suspenseWrapper(AppBatteriesManagementStockControl),
            exact: true
          },
          // {
          //   path: PAGE_URL.BATTERIES_MANAGEMENT_ADD_BATTERY,
          //   pageName: 'Add Battery',
          //   component: suspenseWrapper(AppBatteriesManagementAddBattery),
          //   exact: true
          // },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_INSTALL_BATTERY,
            pageName: 'Install Battery',
            component: suspenseWrapper(AppBatteriesManagementInstallBattery),
            exact: true
          },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_ASSIGN_BATTERY,
            pageName: 'Assign Battery',
            component: suspenseWrapper(AppBatteriesManagementAssignBattery),
            exact: true
          },
          // {
          //   path: PAGE_URL.BATTERIES_MANAGEMENT_RETURN_BATTERY,
          //   pageName: 'Return Battery',
          //   component: suspenseWrapper(AppBatteriesManagementReturnBattery),
          //   exact: true
          // },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_BATTERY_HISTORY,
            pageName: 'Battery History',
            component: suspenseWrapper(AppBatteriesManagementBatteryHistory),
            exact: true
          },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_IMPORT_BATTERY,
            pageName: 'Import Battery',
            component: suspenseWrapper(AppBatteriesManagementImport),
            exact: true
          },
          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_EXPORT_BATTERY,
            pageName: 'Export Battery',
            component: suspenseWrapper(AppBatteriesManagementExport),
            exact: true
          },

          {
            path: PAGE_URL.BATTERIES_MANAGEMENT_DELETE_BATTERY,
            pageName: 'Delete Batteries',
            component: suspenseWrapper(AppBatteriesManagementDeleteBatteries),
            exact: true
          }
        ]
      },
      {
        path: PAGE_URL.EQUIPMENTS_MANAGEMENT,
        pageName: 'Equipments Management',
        component: suspenseWrapper(AppEquipmentManagement),
        routes: [
          {
            path: PAGE_URL.EQUIPMENTS_MANAGEMENT_STOCK_CONTROL,
            pageName: 'Stock Control',
            component: suspenseWrapper(AppEquipmentManagementStockControl),
            exact: true
          }
        ]
      },
      {
        path: PAGE_URL.SITE_VIEW,
        pageName: 'Site View',
        component: suspenseWrapper(AppSiteView),
        exact: true
      },
      {
        path: PAGE_URL.MAP,
        exact: true,
        component: suspenseWrapper(AppSettingsMap),
        pageName: 'Settings Map'
      },
      {
        path: PAGE_URL.BATTERIES_MANAGEMENT_DETAIL_BATTERY,
        pageName: 'Details Battery',
        component: suspenseWrapper(AppBatteriesManagementDetailBattery),
        exact: true
      },
      {
        path: PAGE_URL.BATTERIES_MANAGEMENT_DETAIL_SITE,
        pageName: 'Details Site',
        component: suspenseWrapper(AppBatteriesManagementSiteDetail)
      },
      {
        path: PAGE_URL.BATTERIES_MANAGEMENT_BATTERY_HISTORY_DETAIL,
        pageName: 'Details Historv',
        component: suspenseWrapper(AppBatteriesManagementBatteryHistoryDetail),
        exact: true
      },
      {
        path: PAGE_URL.NEW_FIELD_MODEL_MANAGEMENT,
        pageName: 'New Field Model',
        component: suspenseWrapper(AppNewFieldModelManagement),
        exact: true
      },
      {
        path: PAGE_URL.FIELD_MODEL_MANAGEMENT,
        pageName: 'Field Model',
        component: suspenseWrapper(AppFieldModelManagement),
        exact: true
      },
      {
        path: PAGE_URL.FIELD_MODEL_MANAGEMENT_EDIT,
        pageName: 'Field Model Edit',
        component: suspenseWrapper(AppFieldModelManagementEdit),
        exact: true
      },
      {
        path: PAGE_URL.FIELD_MODEL_MANAGEMENT_CREATE,
        pageName: 'Field Model Create',
        component: suspenseWrapper(AppFieldModelManagementCreate),
        exact: true
      },
      {
        path: PAGE_URL.FIELD_MODEL_MANAGEMENT_IMPORT,
        pageName: 'Field Model Import',
        component: suspenseWrapper(AppFieldModelManagementImport),
        exact: true
      },
      {
        path: PAGE_URL.SITE_VISITS,
        pageName: 'Site Visits',
        component: suspenseWrapper(AppSiteVisits),
        routes: [
          {
            path: PAGE_URL.SITE_VISITS_DASHBOARD,
            pageName: 'Site Visits|Dashboard',
            exact: true,
            component: suspenseWrapper(AppSiteVisitsDashboard)
          },
          {
            path: PAGE_URL.SITE_VISITS_LIST,
            pageName: 'Site Visits|Details',
            exact: true,
            component: suspenseWrapper(AppSiteVisitsDetails)
          },
          {
            path: PAGE_URL.SITE_VISITS_WORK_IN_PROGRESS,
            pageName: 'Site Visits|Work in progress',
            exact: true,
            component: suspenseWrapper(AppSiteVisitsWorkInProgress)
          },
          {
            path: PAGE_URL.SITE_VISITS_TRACKER_LIST,
            pageName: 'Site |Real field visits',
            exact: true,
            component: suspenseWrapper(AppSiteVisitsLive)
          },
          {
            path: PAGE_URL.SITE_VISITS_REAL_TIME_LIST,
            pageName: 'Site Visits|Real time tracker',
            exact: true,
            component: suspenseWrapper(AppSiteVisitsLiveView)
          },
          {
            path: PAGE_URL.SITE_VISITS_BROADCASTER,
            pageName: 'Site Visits|Inbox',
            exact: true,
            component: suspenseWrapper(AppInboxManagementList)
          }
        ]
      },
      {
        path: PAGE_URL.MODEL_MANAGEMENT_LIST,
        exact: true,
        pageName: 'Model Management|List',
        component: suspenseWrapper(AppModelManagementList)
      },
      {
        path: PAGE_URL.GROUPS_MODEL_MANAGEMENT,
        exact: true,
        pageName: 'Model Groups|List',
        component: suspenseWrapper(AppGroupsModelManagement)
      },
      {
        path: PAGE_URL.GROUP_REALTIME_NEW,
        exact: true,
        pageName: 'Realtime Group',
        component: suspenseWrapper(AppSiteVisitsGroupRealtimeNew)
      },
      {
        path: PAGE_URL.GROUP_REALTIME_DELETE,
        exact: true,
        pageName: 'Realtime Group',
        component: suspenseWrapper(AppSiteVisitsGroupRealtimeDelete)
      },
      {
        path: PAGE_URL.GROUP_REALTIME_UPDATE,
        exact: true,
        pageName: 'Realtime Group',
        component: suspenseWrapper(AppSiteVisitsGroupRealtimeUpdate)
      },
      {
        path: PAGE_URL.BATTERIES_MANAGEMENT_EXPORT_LOADER,
        pageName: 'Export Battery Loader',
        search: '?projects=:projects&sites=:sites',
        component: suspenseWrapper(AppBatteriesManagementExportLoader),
        exact: true
      },
      {
        path: '/lab-test',
        exact: true,
        pageName: 'Test',
        component: suspenseWrapper(AppPageTest)
      },
      {
        path: '*',
        component: (): JSX.Element => (
          <AppErrorDispatcher errorStatusCode={404} />
        ),
        pageName: 'Not Found'
      }
    ]
  }
]

export default routes
